import {useDispatch, useSelector} from "react-redux";
import {loadTagCategories, TagsActions, TagsSelector} from "../../reducers/Tags";
import {useEffect, useMemo} from "react";
import {API, Tag} from "@brg/api";
import {useTranslation} from "react-i18next";

export const useGetTagCategories = (tag?: Tag) => {

    const dispatch = useDispatch()
    const { i18n: {language} } = useTranslation();

    const selector = useSelector(TagsSelector);

    useEffect(() => {
        dispatch(loadTagCategories({}))
        dispatch(TagsActions.setTagCategoriesLoaded(true))
    }, []);

    const currentCategories = useMemo(() => {
        const temp = API.toLang(selector?.tagCategories || [], language)
        // @ts-ignore
        return temp?.filter(category => tag?.groupIds?.includes(category?.tagId))?.map(category => category?.name || '')?.join(', ') || ''
    }, [selector?.tagCategories, language, tag])


    return currentCategories
};

export const useGetTagsCategories = (tags: Tag[]): Map<string, string> => {
  const dispatch = useDispatch();
  const {
    i18n: { language },
  } = useTranslation();

  const selector = useSelector(TagsSelector);

  useEffect(() => {
    dispatch(loadTagCategories({}));
    dispatch(TagsActions.setTagCategoriesLoaded(true));
  }, []);

  const currentCategories = useMemo(() => {

    var tagsToCats = new Map<string, string>();

    const temp = API.toLang(selector?.tagCategories || [], language);

    for (let i = 0; i < tags.length; i++) {
      var tagCats =
        temp
          ?.filter((category: any) => tags[i]?.groupIds?.includes(category?.tagId))
          ?.map((category: any) => category?.name || "")
          ?.join(", ") || "";

        tagsToCats.set(tags[i].tagId, tagCats);
    }

    // @ts-ignore
    return tagsToCats;
  }, [selector?.tagCategories, language, tags]);

  return currentCategories;
};import {useDispatch, useSelector} from "react-redux";
import {loadTagCategories, TagsActions, TagsSelector} from "../../reducers/Tags";
import {useEffect, useMemo} from "react";
import {API, Tag} from "@brg/api";
import {useTranslation} from "react-i18next";

export const useGetTagCategories = (tag?: Tag) => {

    const dispatch = useDispatch()
    const { i18n: {language} } = useTranslation();

    const selector = useSelector(TagsSelector);

    useEffect(() => {
        dispatch(loadTagCategories({}))
        dispatch(TagsActions.setTagCategoriesLoaded(true))
    }, []);

    const currentCategories = useMemo(() => {
        const temp = API.toLang(selector?.tagCategories || [], language)
        // @ts-ignore
        return temp?.filter(category => tag?.groupIds?.includes(category?.tagId))?.map(category => category?.name || '')?.join(', ') || ''
    }, [selector?.tagCategories, language, tag])


    return currentCategories
};

export const useGetTagsCategories = (tags: Tag[]): Map<string, string> => {
  const dispatch = useDispatch();
  const {
    i18n: { language },
  } = useTranslation();

  const selector = useSelector(TagsSelector);

  useEffect(() => {
    dispatch(loadTagCategories({}));
    dispatch(TagsActions.setTagCategoriesLoaded(true));
  }, []);

  const currentCategories = useMemo(() => {

    var tagsToCats = new Map<string, string>();

    const temp = API.toLang(selector?.tagCategories || [], language);

    for (let i = 0; i < tags.length; i++) {
      var tagCats =
        temp
          ?.filter((category: any) => tags[i]?.groupIds?.includes(category?.tagId))
          ?.map((category: any) => category?.name || "")
          ?.join(", ") || "";

        tagsToCats.set(tags[i].tagId, tagCats);
    }

    // @ts-ignore
    return tagsToCats;
  }, [selector?.tagCategories, language, tags]);

  return currentCategories;
};